export const ADD_REST = "ADD_REST";
export const DEL_REST = "DEL_REST";

export const GET_REST_LOADING = "GET_REST_LOADING";
export const GET_REST_SUCCESS = "GET_REST_SUCCESS";

export const SET_LOADING_TRUE = "SET_LOADING_TRUE";
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";
